import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import Footer from "../Footer";
import Meta from "../../helpers/meta";
import Nav from "../Nav";
import PromoSlider from "./PromoSlider";
import RestaurantList from "./RestaurantList";

import {Navigate, Link} from "react-router-dom";

import Dialog from "@mui/material/Dialog";
import GpsSelector from "../Location/PopularPlaces/GpsSelector";
import Ink from "react-ink";

// Redux Actions
import {getPromoSlides} from "../../../services/promoSlider/actions";
import {registerPush} from "../../../services/notification/actions";
import {getSingleLanguageData} from "../../../services/languages/actions";
import {getUserNotifications} from "../../../services/alert/actions";
import {resetInfo, resetItems, resetBackup} from "../../../services/items/actions";
import axios from "axios";
import {GET_RESTAURANTS_SLIDES_URL} from "../../../configs";
import DynamicSearchBar from "../../shared/DynamicSearchBar";

const Home = () => {

    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    const heroImage = localStorage.getItem("heroimage");


    const promo_slides = useSelector((state) => state.promo_slides.promo_slides);
    const user = useSelector((state) => state.user.user);
    const languages = useSelector((state) => state.languages.languages);
    const popular_locations = useSelector((state) => state.popular_locations.popular_locations);


    useEffect(() => {
        dispatch(resetItems());
        dispatch(resetInfo());
        dispatch(resetBackup());

        const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
        if (userSetAddress) {
            dispatch(getPromoSlides(userSetAddress.lat, userSetAddress.lng));
        }

        if (user?.success) {
            dispatch(getUserNotifications(user.data.id, user.data.auth_token));
            dispatch(registerPush(user));
        }


        // Check if location needs popup
        const userAlreadySelected = !JSON.parse(localStorage.getItem("userSetAddress"))?.hasOwnProperty(
            "businessLocation"
        );

        if (localStorage.getItem("userAlreadySelectedLocation") == null) {
            setOpen(!userAlreadySelected);
        }
    }, []);


    useEffect(() => {
        if (!languages) return;

        // Todo: Multiple times.
        const savedLang = localStorage.getItem("userPreferedLanguage");

        if (savedLang) {
            dispatch(getSingleLanguageData(savedLang));
        } else if (languages.length) {
            const defaultLang = languages.find((lang) => lang.is_default === 1);
            if (defaultLang) {
                dispatch(getSingleLanguageData(defaultLang.id));
            }
        }
    }, [languages]);


    const handlePopularLocationClick = (location) => {
        const userSetAddress = {
            lat: location.latitude,
            lng: location.longitude,
            address: location.name,
            house: null,
            tag: null,
            businessLocation: true,
        };
        localStorage.setItem("userSetAddress", JSON.stringify(userSetAddress));

        localStorage.setItem("userAlreadySelectedLocation", "true");

        window.location.reload();
    };


    if (window.innerWidth > 768) {
        return <Navigate to="/"/>;
    }

    return (
        <React.Fragment>
            <Meta
                seotitle={localStorage.getItem("seoMetaTitle")}
                seodescription={localStorage.getItem("seoMetaDescription")}
                ogtype="website"
                ogtitle={localStorage.getItem("seoOgTitle")}
                ogdescription={localStorage.getItem("seoOgDescription")}
                ogurl={window.location.href}
                twittertitle={localStorage.getItem("seoTwitterTitle")}
                twitterdescription={localStorage.getItem("seoTwitterDescription")}
            />
            <div
                style={{
                    overflow: "hidden",
                    position: "relative",
                    height: 330,
                }}
            >
                <div
                    style={{
                        inset: 0,
                        background: "rgba(0,0,0,0.09)",
                        position: "absolute",
                        backdropFilter: "blur(0.3px)",
                        zIndex: 1,
                    }}
                />

                <img
                    alt="hero-section"
                    src={heroImage ?
                            "https://food.totalfresh.co/public" + heroImage :
                            "https://i.pinimg.com/736x/ac/44/73/ac4473701beef1b60c071ecf7a66a888.jpg"
                    }
                    style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                    }}
                />

                <Nav
                    logo={true}
                    active_nearme={true}
                    disable_back_button={true}
                    loggedin={user?.success}
                />


                <DynamicSearchBar />
            </div>

            {promo_slides?.mainSlides && (<div style={{
                borderBottomWidth: 6,
                borderBottomStyle: "solid",
                borderBottomColor: "#e3e3e3",
                backgroundColor: "red",
            }}>
                <PromoSlider
                    slides={promo_slides?.mainSlides}
                    size={promo_slides?.mainSlides[0]?.promo_slider?.size}
                />
            </div>)}

            <RestaurantList user={user} slides={promo_slides?.otherSlides}/>

            <Footer active_nearme={true}/>


            <Dialog
                maxWidth={false}
                fullWidth={true}
                fullScreen={true}
                open={open}
                onClose={() => setOpen(false)}
                style={{margin: "auto", position: "absolute", bottom: "0", top: "60%"}}
                PaperProps={{
                    style: {backgroundColor: "#fff", overflowY: "hidden"},
                }}
            >
                <div>
                    <GpsSelector fetchGpsAutomaticallyAndroid={true}/>

                    <div className="p-15 popularLocationPopup">
                        {popular_locations?.length > 0 && (
                            <React.Fragment>
                                <h4 className="text-muted h4">{localStorage.getItem("searchPopularPlaces")}</h4>

                                <div style={{overflowY: "scroll", height: "11rem"}}>
                                    {popular_locations.map((location) => (
                                        <button
                                            key={location.id}
                                            className="btn btn-rounded btn-alt-secondary btn-md mb-15 mr-15"
                                            style={{
                                                position: "relative",
                                                backgroundColor:
                                                    location.is_default && localStorage.getItem("storeColor"),
                                                color: location.is_default && "#fff",
                                            }}
                                            onClick={() => handlePopularLocationClick(location)}
                                        >
                                            <Ink duration="500"/>
                                            {location.name}
                                        </button>
                                    ))}
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    );
};

export default Home;